import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useMaterialUIController } from "context";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/common.css';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from '@mui/material/Backdrop';

function ForgotPasswordConfirm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { MyContext } = controller;
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const [isLoading, setIsLoading] = useState(false);
  
  const { register, setValue, handleSubmit, setError, watch, formState: { errors } } = useForm();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramsObj = Object.fromEntries(urlSearchParams.entries());

    if (paramsObj.email) {
      setValue('email', paramsObj.email);
    }
    if (paramsObj.token) {
      setValue('token', paramsObj.token);
    }
    if (paramsObj.expiry) {
      setValue('expiry', paramsObj.expiry);
    }
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    await axios.post(baseUrl + '/vendor/forgotPasswordConfirm', data,
      {
        headers: { function: azureFunctionVendorFrontendKey }
      }).then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          const message = response.data.message;
          if (response.data.status == 1) {
            toast.success(t(message));
            navigate('/vendor/login');
          }
          else {
            if (message != '')
              toast.error(t(message));
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      }).catch(error => {
        setIsLoading(false);
        toast.error(error);
      });
  };

  return (
    <BasicLayout image={bgImage}>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center" >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>{t('resetPassword')}</MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="email"
                {...register("email")}
                disabled
                fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label={t('newPassword')}
                name="newPassword"
                {...register("newPassword", {
                  required: {
                    value: true,
                    message: t('passwordRequired')
                  },
                  minLength: {
                    value: MyContext.minPasswordLength,
                    message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.newPassword && (<p className="errorMsg">{errors.newPassword.message}</p>)}
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label={t('confirmPassword')}
                name="confirmPassword"
                {...register("confirmPassword", {
                  required: {
                    value: true,
                    message: t('passwordRequired')
                  },
                  minLength: {
                    value: MyContext.minPasswordLength,
                    message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                  },
                  validate: (value) => {
                    if (watch('newPassword') != value) {
                      return t('passwordMismatch');
                    }
                  },
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.confirmPassword && (<p className="errorMsg">{errors.confirmPassword.message}</p>)}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('submit')}</MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ForgotPasswordConfirm;
